import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'aos/dist/aos.css';
import WebFont from 'webfontloader';

export const EnvironmentContext = createContext();
export const Env1Context = createContext();

const root = ReactDOM.createRoot(document.getElementById('root'));

let env = window.location.host;
let env1 = window.location.host;
console.log(env,"envenvenv")
//let env1 =  window.location
console.log(env1,"1111111111")
if(env === "localhost:3000" || env1 === "localhost:3000"){
  env = "https://appdev.signulu.com";
  env1 = "https://dev.signulu.com";
}
else if(env === "devsite.signulu.com" || env1 === "devsite.signulu.com"){
 env = "https://appdev.signulu.com";
 env1 = "https://dev.signulu.com";
}
else if(env === "qasite.signulu.com" || env1 === "qasite.signulu.com"){
  env = "https://appqa.signulu.com";
  env1 = "https://qa.signulu.com";
 }
 else {
   env = "https://app.signulu.com";
   env1 = "https://signulu.com";
 }
console.log(env,"envvvvv")

WebFont.load({
  google: {
    families: ['Lato:400,500,600,700,900', 'sans-serif']
  }
});

root.render(
  <React.StrictMode>
    <EnvironmentContext.Provider value={env}>
    <Env1Context.Provider value={env1}>
      <App />
      </Env1Context.Provider>
    </EnvironmentContext.Provider>
  </React.StrictMode>
);
